import styled from '@emotion/styled';

export const StyledPagePanel = styled('div')<{
  $overflow: 'hidden' | 'visible';
  $padding: number | string;
}>(({ theme, $overflow, $padding }) => ({
  backgroundColor:
    theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
  border: `1px solid ${
    theme.colorScheme === 'dark' ? theme.colors.dark[5] : '#F3F4F6'
  }`,
  overflow: $overflow,
  padding: $padding,
}));
